import { Route, Routes } from 'react-router-dom';
import Cities from '../pages/Cities';
import ClientDashboard from '../pages/ClientDashboard';
import ClientDescription from '../pages/ClientDescription';
import ClientLogin from '../pages/ClientLogin';
import ClientRegister from '../pages/ClientRegister';
import ClientUploads from '../pages/ClientUploads';
import ForgotPassword from '../pages/ForgotPassword';
import Home from '../pages/Home';
import Model from '../pages/Model';
import ModelAbout from '../pages/ModelAbout';
import ModelDashboard from '../pages/ModelDashboard';
import ModelDescription from '../pages/ModelDescription';
import ModelFilter from '../pages/ModelFilter';
import ModelLogin from '../pages/ModelLogin';
import ModelMidias from '../pages/ModelMidias';
import ModelRegister from '../pages/ModelRegister';
import ModelRequired from '../pages/ModelRequired';
import ModelService from '../pages/ModelService';
import ModelUploads from '../pages/ModelUploads';
import ModelValue from '../pages/ModelValue';
import PaymentCheckout from '../pages/PaymentCheckout';
import Plans from '../pages/Plans';
import Policies from '../pages/Policies';
import ResetPassword from '../pages/ResetPassword';
import Term from '../pages/Term';
import ProtectedRoute from './protectedRoute';

export default function RoutesComp() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <ProtectedRoute
            loggedComponent={<Home />}
            defaultComponent={<Home />}
          />
        }
      />

      <Route
        path="/cities/:id"
        element={
          <ProtectedRoute
            loggedComponent={<Cities />}
            defaultComponent={<Cities />}
          />
        }
      />

      <Route
        path="/plans"
        element={
          <ProtectedRoute
            loggedComponent={<Plans />}
            defaultComponent={<Plans />}
          />
        }
      />

      <Route path="/payment" element={<PaymentCheckout />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />

      <Route
        path="/term"
        element={
          <ProtectedRoute
            loggedComponent={<Term />}
            defaultComponent={<Term />}
          />
        }
      />

      <Route
        path="/policies"
        element={
          <ProtectedRoute
            loggedComponent={<Policies />}
            defaultComponent={<Policies />}
          />
        }
      />

      {/* Proteção de usuário */}
      <Route
        path="/clientregister"
        element={
          <ProtectedRoute
            loggedComponent={<Home />}
            defaultComponent={<ClientRegister />}
          />
        }
      />

      <Route
        path="/clientlogin"
        element={
          <ProtectedRoute
            loggedComponent={<Home />}
            defaultComponent={<ClientLogin />}
          />
        }
      />

      <Route
        path="/clientdescription"
        element={
          <ProtectedRoute
            loggedComponent={<ClientDescription />}
            defaultComponent={<Home />}
            isClient
          />
        }
      />

      <Route
        path="/clientuploads"
        element={
          <ProtectedRoute
            loggedComponent={<ClientUploads />}
            defaultComponent={<Home />}
            isClient
          />
        }
      />

      <Route
        path="/clientdashboard"
        element={
          <ProtectedRoute
            loggedComponent={<ClientDashboard />}
            defaultComponent={<Home />}
            isClient
          />
        }
      />

      {/* MODEL */}

      <Route
        path="/modelregister"
        element={
          <ProtectedRoute
            loggedComponent={<Home />}
            defaultComponent={<ModelRegister />}
          />
        }
      />

      <Route
        path="/modellogin"
        element={
          <ProtectedRoute
            loggedComponent={<Home />}
            defaultComponent={<ModelLogin />}
          />
        }
      />

      <Route
        path="/model/:id"
        element={
          <ProtectedRoute
            loggedComponent={<Model />}
            defaultComponent={<Model />}
          />
        }
      />

      <Route
        path="/modeldashboard"
        element={
          <ProtectedRoute
            loggedComponent={<ModelDashboard />}
            defaultComponent={<Home />}
            isModel
          />
        }
      />

      <Route
        path="/modelmidias"
        element={
          <ProtectedRoute
            loggedComponent={<ModelMidias />}
            defaultComponent={<Home />}
            isModel
          />
        }
      />

      {/* Verification - Required */}
      <Route
        path="/modelregister/v1"
        element={
          <ProtectedRoute
            requireVerification
            loggedComponent={<Home />}
            defaultComponent={<Home />}
          />
        }
      />
      <Route
        path="/modelregister/v2"
        element={
          <ProtectedRoute
            requireVerification
            loggedComponent={<Home />}
            defaultComponent={<Home />}
          />
        }
      />
      <Route
        path="/modelregister/v3"
        element={
          <ProtectedRoute
            requireVerification
            loggedComponent={<Home />}
            defaultComponent={<Home />}
          />
        }
      />
      <Route
        path="/modelregister/v4"
        element={
          <ProtectedRoute
            requireVerification
            loggedComponent={<Home />}
            defaultComponent={<Home />}
          />
        }
      />

      <Route
        path="/modelregister/v5"
        element={
          <ProtectedRoute
            requireVerification
            loggedComponent={<Home />}
            defaultComponent={<Home />}
          />
        }
      />

      <Route
        path="/modelrequired"
        element={
          <ProtectedRoute
            loggedComponent={<ModelRequired />}
            defaultComponent={<Home />}
            isModel
            isUnique
          />
        }
      />

      <Route
        path="/modeldescription"
        element={
          <ProtectedRoute
            loggedComponent={<ModelDescription />}
            defaultComponent={<Home />}
            isModel
          />
        }
      />

      <Route
        path="/modelvalue"
        element={
          <ProtectedRoute
            loggedComponent={<ModelValue />}
            defaultComponent={<Home />}
            isModel
          />
        }
      />

      <Route
        path="/modelservice"
        element={
          <ProtectedRoute
            loggedComponent={<ModelService />}
            defaultComponent={<Home />}
            isModel
          />
        }
      />

      <Route
        path="/modelfilter"
        element={
          <ProtectedRoute
            loggedComponent={<ModelFilter />}
            defaultComponent={<Home />}
            isModel
          />
        }
      />

      <Route
        path="/modelabout"
        element={
          <ProtectedRoute
            loggedComponent={<ModelAbout />}
            defaultComponent={<Home />}
            isModel
          />
        }
      />

      <Route
        path="/modeluploads"
        element={
          <ProtectedRoute
            loggedComponent={<ModelUploads />}
            defaultComponent={<Home />}
            isModel
          />
        }
      />
    </Routes>
  );
}
